import { DAY_KEYS, formatTo24Hour } from '@/utils/time'
import type { CobaltProviderDay, CobaltProviderShift } from './types'

export function providerShiftTime(value: string) {
  return formatTo24Hour(value.replace(/^T/, ''))
}

function shiftKey(shifts: CobaltProviderShift[]) {
  return JSON.stringify(
    shifts
      .map((shift) => ({
        closed: shift.closed ?? false,
        start: shift.closed ? null : providerShiftTime(shift.start),
        end: shift.closed ? null : providerShiftTime(shift.end),
        facility: shift.facility_name ?? null,
        startDate: shift.set_start_date ?? null,
        endDate: shift.set_end_date ?? null,
        recurrence: shift.recurrence ?? null,
      }))
      .toSorted((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)))
  )
}

export function groupProviderHours(hours: CobaltProviderDay[]) {
  const groups = new Map<
    string,
    { days: string[]; shifts: CobaltProviderShift[] }
  >()
  const dayIndex = (day: string) =>
    DAY_KEYS.findIndex(({ key }) => key === day.toLowerCase())
  for (const day of hours.toSorted(
    (a, b) => dayIndex(a.day) - dayIndex(b.day)
  )) {
    const key = shiftKey(day.shifts)
    const group = groups.get(key)
    if (group) group.days.push(day.day)
    else groups.set(key, { days: [day.day], shifts: day.shifts })
  }
  return [...groups.values()].map(({ days, shifts }) => ({
    days:
      days.length === 5 && days.every((day, i) => dayIndex(day) === i)
        ? 'Mon–Fri'
        : days.length === 7 && days.every((day, i) => dayIndex(day) === i)
          ? 'Daily'
          : days
              .map((day) => (dayIndex(day) < 0 ? day : day.slice(0, 3)))
              .join(', '),
    shifts,
  }))
}
